import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import getLogo from '../../utils/getLogo';
import './EventItem.css';

const EventItem = ({ event }) => {
	const { i18n } = useTranslation();
    const navigate = useNavigate();
    const lang = i18n.language;
    const img = getLogo(event);

	return (
        <div
            className='EventItem'
            onClick={() => navigate('exhibitors/' + event._id)}
        >
            <img src={img} alt='logo'/>
            <div>{event.name[lang]}</div>
        </div>
	);
};

EventItem.propTypes = {
    event: PropTypes.object.isRequired,
};

export default EventItem;
